var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiUx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 327,
    viewBox: "0 0 490 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_7406)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.382 319.619H213.641C219.516 316.682 225.391 313.744 232.735 311.646C258.754 303.882 280.576 312.485 293.376 319.619H421.791C443.194 297.587 452.426 265.064 442.984 233.589C434.8 206.312 418.434 196.24 411.509 173.369C406.683 156.792 406.893 140.216 411.3 124.688C411.3 124.688 411.3 124.688 411.09 124.478C413.608 111.259 413.188 97.2006 408.991 83.142C395.353 36.7698 346.462 10.1215 300.09 23.9702C252.249 38.0288 242.177 78.5258 242.177 78.5258C235.043 102.027 216.578 121.541 191.399 128.885C165.8 136.439 149.433 130.144 128.45 136.439C74.5239 152.386 43.679 209.039 59.626 262.966C66.5504 287.306 81.8679 306.82 101.382 319.619Z",
    fill: "#D7E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.162 109.371C215.109 99.7185 220.985 79.9946 212.172 65.5164C203.359 50.8283 182.166 48.73 166.219 58.3822C150.272 68.0343 145.446 85.66 154.259 100.348C163.072 115.036 183.006 119.023 199.162 109.371Z",
    fill: "#D7E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.148 167.283C429.345 180.503 442.354 188.057 454.315 184.28C466.275 180.503 471.521 165.815 467.534 152.595C463.337 139.376 451.587 132.871 439.627 136.648C427.456 140.425 420.952 154.274 425.148 167.283Z",
    fill: "#D7E9FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.841 175.713L174.247 175.503C176.346 172.566 178.234 168.789 179.283 164.173L175.926 163.963L179.703 162.704C180.123 160.606 180.332 158.297 180.332 155.779C180.332 155.779 174.247 156.199 167.953 159.556L167.743 162.494L167.113 159.976C163.336 162.074 159.559 165.222 157.251 169.838L158.3 174.664L156.412 171.726C155.573 173.615 155.153 175.713 154.733 178.231C154.523 182.847 154.733 185.785 154.733 185.785H161.868C161.868 185.785 168.162 183.477 173.408 176.972L169.841 175.713Z",
    fill: "#19904B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.202 180.12C155.992 177.392 155.153 175.084 153.894 173.195L152.845 175.503L153.265 172.356C150.956 169.418 148.019 167.32 145.291 166.271L145.081 168.369L144.452 166.061C141.094 164.802 138.157 164.592 138.157 164.592C138.157 168.159 138.786 171.097 139.626 173.615L141.514 174.244L140.045 174.454C141.514 178.021 143.612 180.539 145.501 182.218L149.068 182.428L146.76 183.267C149.278 185.156 151.166 185.785 151.166 185.785H156.202C156.202 185.575 156.202 183.477 156.202 180.12Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M143.403 169.838C142.353 168.789 140.045 166.271 140.045 166.271C140.045 166.271 142.773 168.159 143.822 169.209C153.055 178.021 155.153 185.156 155.153 185.575H154.733H154.314C154.104 184.736 151.796 177.812 143.403 169.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M157.251 185.575H156.412C157.041 183.267 161.448 170.468 174.457 159.976C175.506 159.137 178.234 157.668 178.234 157.668C178.234 157.668 176.136 159.556 175.087 160.396C162.497 170.468 158.091 182.847 157.251 185.575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.595 209.496H148.019L142.983 190.191H169.421L164.595 209.496Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52 185.156H140.885V192.5H171.52V185.156Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.09 307.486V316.089H260.277V307.066L269.09 307.486Z",
    fill: "#FFAD97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.09 313.151C269.09 313.151 271.188 314.41 271.188 317.348C271.188 320.285 271.188 323.433 271.188 323.433H240.763C240.763 323.433 240.134 319.866 244.33 319.866C248.527 319.866 255.871 316.928 257.13 315.669C258.809 313.781 260.068 313.151 261.536 313.151C262.795 313.151 269.09 313.151 269.09 313.151Z",
    fill: "url(#paint0_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.302 322.594H200.056L182.85 214.741H188.306L205.302 322.594Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.306 214.741L205.302 322.594H207.82L190.614 214.741H188.306Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.871 322.594H361.415L344.419 214.741H349.874L366.871 322.594Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.874 214.741L366.871 322.594H369.179L352.182 214.741H349.874Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.283 322.174H285.457L302.453 214.532H307.279L290.283 322.174Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.279 214.532L290.283 322.174H292.381L309.377 214.532H307.279Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.246 322.594H122L138.996 214.741H144.242L127.246 322.594Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.242 214.741L127.246 322.594H129.344L146.55 214.741H144.242Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.154 208.866H133.331V215.581H313.154V208.866Z",
    fill: "url(#paint1_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M179.913 208.866H133.121V215.581H179.913V208.866Z",
    fill: "url(#paint2_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.933 190.821H239.924V206.768H252.933V190.821Z",
    fill: "#97A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.134 190.821H237.196V206.768H240.134V190.821Z",
    fill: "#747EC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.587 307.486V316.089H300.984V307.066L309.587 307.486Z",
    fill: "#FFAD97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.587 313.151C309.587 313.151 311.685 314.41 311.685 317.348C311.685 320.285 311.685 323.433 311.685 323.433H281.26C281.26 323.433 280.631 319.866 284.827 319.866C289.024 319.866 296.368 316.928 297.627 315.669C299.306 313.781 300.565 313.151 302.033 313.151C303.292 313.151 309.587 313.151 309.587 313.151Z",
    fill: "url(#paint3_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.292 234.675C289.024 241.809 295.529 295.106 299.515 307.906C305.81 307.906 311.685 307.906 311.685 307.906C311.685 307.906 315.462 270.136 315.462 261.324C315.253 246.635 303.292 234.675 303.292 234.675Z",
    fill: "url(#paint4_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.685 230.269C311.685 230.269 277.903 227.541 263.635 234.675C249.366 241.809 255.871 295.106 259.858 307.906C266.153 307.906 272.028 307.906 272.028 307.906C272.028 307.906 275.805 270.136 275.805 261.324C275.805 252.511 283.359 255.448 284.618 254.189C286.086 252.721 314.413 256.917 319.029 250.412C323.436 243.698 311.685 230.269 311.685 230.269Z",
    fill: "url(#paint5_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.672 123.885C315.672 123.885 315.462 131.229 315.462 132.279C315.462 133.328 313.574 136.685 312.525 137.524C311.685 138.364 312.735 140.042 313.994 140.042C315.253 140.042 315.043 141.721 315.043 143.19C315.043 146.337 314.833 155.989 324.905 149.904C324.905 149.904 326.793 153.891 326.164 155.989L341.901 154.311C341.901 154.311 340.222 150.744 340.432 147.176C340.852 143.609 328.262 119.689 315.672 123.885Z",
    fill: "url(#paint6_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.784 116.541C319.869 113.394 337.494 109.197 341.691 120.109C341.691 120.109 346.307 120.948 346.097 127.243C345.888 132.908 344.629 148.435 337.285 148.226C329.521 148.016 326.583 145.078 326.583 145.078C326.583 145.078 332.039 137.524 328.472 134.797C327.423 133.957 326.164 134.587 326.164 136.685C326.164 138.574 326.374 147.806 325.115 150.324C323.226 154.311 319.869 153.681 318.61 153.262C314.413 152.003 314.413 142.56 315.462 145.498C316.512 148.226 319.869 148.226 321.547 146.547C323.226 144.868 324.695 134.587 324.695 134.587C324.695 129.761 323.226 123.046 315.882 123.885C315.882 123.885 313.994 124.515 311.476 124.725C308.958 124.935 307.279 119.899 313.784 116.541Z",
    fill: "#3F3F5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.95 153.052C342.95 153.052 366.031 153.471 366.031 182.428C366.031 211.384 361.415 246.216 361.415 246.216H321.128C321.128 246.216 311.685 244.747 311.685 231.108C311.685 217.259 313.154 193.549 311.476 182.218C309.797 170.887 305.391 160.396 323.856 156.619C339.173 153.262 342.95 153.052 342.95 153.052Z",
    fill: "url(#paint7_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.068 206.348H223.977V208.866H260.068V206.348Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.355 188.723C300.355 190.611 298.886 192.08 296.997 192.08H199.637C197.748 192.08 196.279 190.611 196.279 188.723V130.81C196.279 128.921 197.748 127.453 199.637 127.453H296.997C298.886 127.453 300.355 128.921 300.355 130.81V188.723Z",
    fill: "#999BC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.637 130.81C199.637 136.056 199.637 179.28 199.637 184.316C205.722 184.316 291.122 184.316 296.997 184.316C296.997 179.071 296.997 135.846 296.997 130.81C291.122 130.81 205.722 130.81 199.637 130.81Z",
    fill: "#2E3545"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M284.408 254.189C285.877 252.721 314.203 256.917 318.82 250.412C320.708 247.894 319.869 244.118 318.4 240.76C315.462 247.055 312.105 251.252 307.909 251.252H285.457C282.309 251.252 280.841 253.14 280.631 255.029C282.309 254.609 283.988 254.819 284.408 254.189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M366.241 182.428C366.241 181.798 366.241 181.169 366.241 180.539C356.169 180.539 338.544 180.12 331.409 202.152C326.583 217.05 322.387 234.465 316.931 244.117C319.239 246.006 321.338 246.216 321.338 246.216H361.625C361.415 246.216 366.241 211.384 366.241 182.428Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.389 198.794C258.389 198.794 248.737 197.535 245.589 197.955C242.442 198.165 239.714 199.214 237.196 201.522C234.678 203.83 231.95 206.138 233.629 206.768C235.308 207.397 236.357 206.768 238.035 205.089C239.714 203.621 242.442 204.04 243.701 205.299C244.75 206.558 249.156 206.558 251.884 206.558C254.612 206.558 256.081 204.88 258.389 206.348C260.277 207.607 258.389 198.794 258.389 198.794Z",
    fill: "url(#paint8_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.567 205.929C236.567 205.929 237.406 207.188 238.875 206.768C240.134 206.348 242.022 204.04 243.281 204.46C244.54 204.67 243.701 203.621 243.701 203.621C243.701 203.621 240.134 203.621 239.924 203.621C239.504 203.621 236.357 204.67 236.567 205.929Z",
    fill: "#FFAD97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.344 205.509C240.344 205.509 240.553 206.558 241.603 206.558C242.652 206.558 243.281 205.089 244.121 205.299C244.96 205.509 245.17 204.67 245.17 204.67L243.071 203.83C242.862 204.04 240.973 204.88 240.344 205.509Z",
    fill: "#FFAD97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.451 324.482H360.366L347.566 261.114H353.651L366.451 324.482Z",
    fill: "#D59758"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M364.982 324.482H363.723L350.924 261.114H352.183L364.982 324.482Z",
    fill: "#7D62BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.513 323.643C358.897 323.643 357.428 325.951 357.428 326.37C357.428 326.79 357.848 327 358.267 327H368.759C369.179 327 369.598 326.79 369.598 326.37C369.598 325.951 368.129 323.643 363.513 323.643Z",
    fill: "#D59758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.672 324.482H321.757L334.557 261.114H328.472L315.672 324.482Z",
    fill: "#D59758"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M317.141 324.482H318.4L331.2 261.114H329.941L317.141 324.482Z",
    fill: "#7D62BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4 323.643C323.016 323.643 324.485 325.951 324.485 326.37C324.485 326.79 324.065 327 323.646 327H313.154C312.735 327 312.315 326.79 312.315 326.37C312.315 325.951 313.784 323.643 318.4 323.643Z",
    fill: "#D59758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.68 324.482H287.765L300.565 261.114H294.48L281.68 324.482Z",
    fill: "#D59758"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M283.149 324.482H284.408L297.207 261.114H295.948L283.149 324.482Z",
    fill: "#7D62BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.618 323.643C289.234 323.643 290.703 325.951 290.703 326.37C290.703 326.79 290.283 327 289.863 327H279.372C278.952 327 278.533 326.79 278.533 326.37C278.533 325.951 280.001 323.643 284.618 323.643Z",
    fill: "#D59758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.249 324.482H326.164L313.364 261.114H319.449L332.249 324.482Z",
    fill: "#D59758"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M330.78 324.482H329.521L316.721 261.114H317.98L330.78 324.482Z",
    fill: "#7D62BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.521 323.643C324.905 323.643 323.436 325.951 323.436 326.37C323.436 326.79 323.856 327 324.275 327H334.767C335.186 327 335.606 326.79 335.606 326.37C335.606 325.951 334.137 323.643 329.521 323.643Z",
    fill: "#D59758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.035 263.212C356.169 263.212 358.477 259.435 358.477 258.806C358.477 258.176 357.848 257.966 357.009 257.966H341.062C340.222 257.966 339.593 258.176 339.593 258.806C339.803 259.645 342.111 263.212 349.035 263.212Z",
    fill: "#7A3D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.78 263.212C337.914 263.212 340.222 259.435 340.222 258.806C340.222 258.176 339.593 257.966 338.753 257.966H322.806C321.967 257.966 321.338 258.176 321.338 258.806C321.338 259.645 323.646 263.212 330.78 263.212Z",
    fill: "#7A3D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.627 263.212C304.761 263.212 307.069 259.435 307.069 258.806C307.069 258.176 306.44 257.966 305.6 257.966H289.653C288.814 257.966 288.185 258.176 288.185 258.806C288.185 259.645 290.493 263.212 297.627 263.212Z",
    fill: "#7A3D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.092 263.212C323.226 263.212 325.534 259.435 325.534 258.806C325.534 258.176 324.905 257.966 324.065 257.966H308.118C307.279 257.966 306.65 258.176 306.65 258.806C306.859 259.645 309.168 263.212 316.092 263.212Z",
    fill: "#7A3D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.732 230.059C376.732 216.63 377.782 201.942 377.782 196.276C377.782 190.611 377.572 181.588 367.5 181.588C357.428 181.588 339.803 181.169 332.459 203.201C325.324 225.023 319.869 252.091 309.377 252.091C298.676 252.091 290.283 252.091 286.926 252.091C283.778 252.091 282.1 254.189 282.1 256.078C282.1 257.966 283.568 259.855 287.765 259.855C291.962 259.855 332.459 259.855 345.678 259.855C358.897 260.065 376.732 257.756 376.732 230.059Z",
    fill: "url(#paint9_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M290.703 255.448H310.007C323.226 255.448 328.891 228.38 336.235 206.558C343.37 184.736 360.995 184.946 371.277 184.946C373.165 184.946 374.634 185.156 375.683 185.785C374.215 183.477 371.697 181.588 367.29 181.588C357.218 181.588 339.593 181.169 332.249 203.201C325.115 225.023 319.659 252.091 309.168 252.091H286.716C283.568 252.091 281.89 254.189 281.89 256.078C283.359 255.238 282.939 255.448 290.703 255.448Z",
    fill: "#F8981C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 132.488H200.686V176.553H269.51V132.488Z",
    fill: "#334D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51 132.488H200.686V137.944H269.51V132.488Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.302 133.747H201.945V137.105H205.302V133.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.563 133.747H211.597V137.105H253.563V133.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.043 136.265L202.994 135.216L204.043 134.377V136.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.918 133.747H206.561V137.105H209.918V133.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.82 136.265L208.869 135.216L207.82 134.377V136.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.018 135.216C259.018 136.056 258.389 136.685 257.55 136.685C256.71 136.685 256.081 136.056 256.081 135.216C256.081 134.377 256.71 133.747 257.55 133.747C258.389 133.957 259.018 134.587 259.018 135.216Z",
    fill: "#FB392E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.425 135.216C263.425 136.056 262.795 136.685 261.956 136.685C261.117 136.685 260.487 136.056 260.487 135.216C260.487 134.377 261.117 133.747 261.956 133.747C262.795 133.957 263.425 134.587 263.425 135.216Z",
    fill: "#FECB15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.831 135.216C267.831 136.056 267.202 136.685 266.362 136.685C265.523 136.685 264.894 136.056 264.894 135.216C264.894 134.377 265.523 133.747 266.362 133.747C267.202 133.957 267.831 134.587 267.831 135.216Z",
    fill: "#26A659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.869 140.462H208.03V173.825H208.869V140.462Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 141.511H204.883V142.77H206.141V141.511Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 144.449H204.883V145.708H206.141V144.449Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 147.176H204.883V148.435H206.141V147.176Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 150.114H204.883V151.373H206.141V150.114Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 152.842H204.883V154.101H206.141V152.842Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 155.779H204.883V157.038H206.141V155.779Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 158.507H204.883V159.766H206.141V158.507Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 161.445H204.883V162.704H206.141V161.445Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 164.173H204.883V165.432H206.141V164.173Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 167.11H204.883V168.369H206.141V167.11Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 169.838H204.883V171.097H206.141V169.838Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.807 141.301L210.968 142.35V142.56L211.807 143.4H212.017C212.017 143.4 212.017 143.4 212.017 143.19C212.017 143.19 212.017 143.19 212.017 142.98C212.017 142.98 211.387 142.35 211.177 142.141C211.387 141.931 212.017 141.301 212.017 141.301C212.017 141.301 212.017 141.301 212.017 141.091C212.017 141.091 212.017 141.091 212.017 140.882C212.017 141.091 212.017 141.091 211.807 141.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.213 141.301C216.213 141.511 216.213 141.511 216.213 141.511C216.213 141.511 216.843 142.141 217.053 142.35C216.843 142.56 216.213 143.19 216.213 143.19C216.213 143.19 216.213 143.19 216.213 143.4C216.213 143.4 216.213 143.4 216.213 143.609H216.423L217.262 142.77V142.56L216.423 141.511C216.423 141.091 216.423 141.091 216.213 141.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.744 141.301L213.066 142.98V143.19H213.276L214.954 141.511V141.301C214.954 141.301 214.954 141.301 214.744 141.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.807 171.936L210.968 172.985V173.195L211.807 174.035H212.017C212.017 174.035 212.017 174.035 212.017 173.825C212.017 173.825 212.017 173.825 212.017 173.615C212.017 173.615 211.387 172.985 211.177 172.776C211.387 172.566 212.017 171.936 212.017 171.936C212.017 171.936 212.017 171.936 212.017 171.727C212.017 171.727 212.017 171.727 212.017 171.517C212.017 171.727 212.017 171.727 211.807 171.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.213 171.936C216.213 172.146 216.213 172.146 216.213 172.146C216.213 172.146 216.843 172.776 217.053 172.985C216.843 173.195 216.213 173.825 216.213 173.825C216.213 173.825 216.213 173.825 216.213 174.035C216.213 174.035 216.213 174.035 216.213 174.244H216.423L217.262 173.405V173.195L216.423 172.146C216.423 171.726 216.423 171.726 216.213 171.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.744 171.936L213.066 173.615V173.825H213.276L214.954 172.146V171.936C214.954 171.936 214.954 171.936 214.744 171.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.374 144.239H209.499V145.498H215.374V144.239Z",
    fill: "#E29616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.213 159.766H209.499V161.025H216.213V159.766Z",
    fill: "#F19B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.905 170.048H209.499V171.307H213.905V170.048Z",
    fill: "#F19B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.41 146.757H210.968V148.016H220.41V146.757Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.571 162.284H210.968V163.543H219.571V162.284Z",
    fill: "#FBDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.361 164.802H210.968V166.061H219.361V164.802Z",
    fill: "#89C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 167.32H210.968V168.579H215.584V167.32Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.937 167.32H216.633V168.579H235.937V167.32Z",
    fill: "#FBDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.468 164.802H220.41V166.061H234.468V164.802Z",
    fill: "#FBDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.134 164.802H235.518V166.061H240.134V164.802Z",
    fill: "#E29616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.045 162.284H242.022V163.543H251.045V162.284Z",
    fill: "#89C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.973 162.284H220.62V163.543H240.973V162.284Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.915 146.757H221.459V148.016H226.915V146.757Z",
    fill: "#FBDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.262 152.003H210.968V153.262H217.262V152.003Z",
    fill: "#FBDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.383 152.003H218.312V153.262H228.383V152.003Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.406 146.757H227.754V148.016H237.406V146.757Z",
    fill: "#89C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.669 149.485H210.968V150.744H221.669V149.485Z",
    fill: "#89C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.419 149.485H222.928V150.744H233.419V149.485Z",
    fill: "#E29616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.603 149.485H234.259V150.744H241.603V149.485Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.767 154.521H210.968V155.779H223.767V154.521Z",
    fill: "#89C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.321 154.521H224.606V155.779H231.321V154.521Z",
    fill: "#FBDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.767 157.038H210.968V158.297H223.767V157.038Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.357 157.038H224.606V158.297H236.357V157.038Z",
    fill: "#89C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.799 154.521H232.58V155.779H245.799V154.521Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.571 144.239H216.633V145.498H219.571V144.239Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.109 148.645H247.688V178.861H295.109V148.645Z",
    fill: "#38424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.109 148.645H247.688V152.422H295.109V148.645Z",
    fill: "#474E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.465 150.534C251.465 151.163 251.045 151.583 250.415 151.583C249.786 151.583 249.366 151.163 249.366 150.534C249.366 149.904 249.786 149.485 250.415 149.485C251.045 149.694 251.465 150.114 251.465 150.534Z",
    fill: "#FB392E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.402 150.534C254.402 151.163 253.982 151.583 253.353 151.583C252.723 151.583 252.304 151.163 252.304 150.534C252.304 149.904 252.723 149.485 253.353 149.485C253.982 149.694 254.402 150.114 254.402 150.534Z",
    fill: "#FECB15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34 150.534C257.34 151.163 256.92 151.583 256.291 151.583C255.661 151.583 255.241 151.163 255.241 150.534C255.241 149.904 255.661 149.485 256.291 149.485C256.92 149.694 257.34 150.114 257.34 150.534Z",
    fill: "#25B2C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.822 156.829H250.835V157.668H254.822V156.829Z",
    fill: "#E29616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.451 167.32H250.835V168.159H255.451V167.32Z",
    fill: "#F19B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.982 172.566H250.835V173.405H253.982V172.566Z",
    fill: "#F19B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.389 158.507H251.884V159.347H258.389V158.507Z",
    fill: "#0298AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.759 169.209H251.884V170.048H257.759V169.209Z",
    fill: "#DFB815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.759 170.887H251.884V171.726H257.759V170.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.041 170.887H258.389V171.726H268.041V170.887Z",
    fill: "#DFB815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.818 170.887H268.671V171.726H271.818V170.887Z",
    fill: "#F9392A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.162 169.209H273.077V170.048H279.162V169.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.447 169.209H258.389V170.048H272.447V169.209Z",
    fill: "#0298AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.795 158.507H259.018V159.347H262.795V158.507Z",
    fill: "#DFB815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.081 162.074H251.884V162.914H256.081V162.074Z",
    fill: "#DFB815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.635 162.074H256.71V162.914H263.635V162.074Z",
    fill: "#0298AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.139 158.507H263.425V159.347H270.139V158.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.228 160.396H251.884V161.235H259.228V160.396Z",
    fill: "#F83A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.992 160.396H259.858V161.235H266.992V160.396Z",
    fill: "#E29616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.867 160.396H267.831V161.235H272.867V160.396Z",
    fill: "#0298AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.697 163.963H251.884V164.802H260.697V163.963Z",
    fill: "#F83A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.733 163.963H261.117V164.802H265.733V163.963Z",
    fill: "#DFB815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.697 165.641H251.884V166.481H260.697V165.641Z",
    fill: "#0298AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3 165.641H261.117V166.481H269.3V165.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.595 163.963H266.572V164.802H275.595V163.963Z",
    fill: "#0298AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.759 156.829H255.661V157.668H257.759V156.829Z",
    fill: "#DFB815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.869 183.477C319.869 183.477 330.15 170.258 323.646 163.753C317.141 157.248 311.266 160.396 304.551 171.936C298.676 181.798 291.962 191.87 288.394 194.178C284.618 196.486 260.068 197.326 260.068 197.326C260.068 197.326 257.13 198.375 257.13 202.571C257.13 206.768 258.599 208.866 263.844 208.866C269.09 208.866 278.952 208.866 287.345 208.866C295.948 208.866 303.082 205.509 307.699 199.424C311.895 193.549 319.869 183.477 319.869 183.477Z",
    fill: "url(#paint10_linear_7_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.882 206.348C204.882 207.817 203.624 208.866 202.365 208.866H192.293C190.824 208.866 189.775 207.607 189.775 206.348V193.339H204.882V206.348Z",
    fill: "#1652AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.079 195.647C208.03 194.808 206.561 194.388 204.883 194.388V196.486C206.141 196.486 206.981 196.696 207.61 197.116C208.24 197.745 208.45 198.585 208.45 199.844C208.24 201.312 207.61 203.201 206.351 204.04C205.932 204.25 205.512 204.46 205.092 204.46V206.348V206.558C206.141 206.558 206.981 206.348 207.82 205.929C209.918 204.67 210.968 202.152 210.968 200.053C210.968 198.165 210.338 196.696 209.079 195.647Z",
    fill: "#1652AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M204.883 194.388V196.486C205.092 196.486 205.302 196.486 205.722 196.486V194.388C205.302 194.388 205.092 194.388 204.883 194.388ZM204.883 206.348V206.558C205.092 206.558 205.302 206.558 205.722 206.558V206.348V204.46C205.512 204.46 205.302 204.67 204.883 204.46V206.348Z",
    fill: "#1652AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M191.663 209.076C191.873 209.076 192.083 209.076 192.293 209.076H194.601V193.549H191.873V209.076H191.663Z",
    fill: "#012A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.279 180.33C196.07 180.33 195.86 180.539 195.86 180.749C195.86 180.959 196.07 181.169 196.279 181.169H206.141C206.981 181.169 207.82 181.798 207.82 182.847V183.267C207.82 183.687 207.61 184.106 207.4 184.316C207.191 184.526 206.771 184.736 206.351 184.736H189.985C188.516 184.736 187.467 185.575 187.467 186.624C187.467 187.674 188.516 188.513 189.985 188.513H194.601C195.02 188.513 195.44 188.723 195.65 188.933C195.86 189.142 196.07 189.352 196.07 189.772V191.45C196.07 191.66 196.279 191.87 196.489 191.87C196.699 191.87 196.909 191.66 196.909 191.45V189.772C196.909 189.142 196.699 188.513 196.07 188.093C195.65 187.674 195.02 187.464 194.181 187.464H189.565C188.726 187.464 187.886 187.044 187.886 186.624C187.886 186.205 188.516 185.785 189.565 185.785H205.932C206.561 185.785 207.191 185.575 207.82 184.946C208.24 184.526 208.659 183.897 208.659 183.057V182.638C208.659 181.169 207.4 180.12 206.141 180.12H196.279V180.33Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.169 55.9008C356.169 69.1201 345.468 79.6115 332.459 79.6115C319.239 79.6115 308.748 68.9102 308.748 55.9008C308.748 42.6816 319.449 32.1902 332.459 32.1902C345.678 32.1902 356.169 42.8914 356.169 55.9008Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M351.343 55.9008C351.343 66.1825 342.95 74.5756 332.668 74.5756C322.387 74.5756 313.994 66.1825 313.994 55.9008C313.994 45.6192 322.387 37.226 332.668 37.226C342.95 37.226 351.343 45.6192 351.343 55.9008Z",
    fill: "#178C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.245 55.9009C349.245 65.1333 341.691 72.6872 332.459 72.6872C323.226 72.6872 315.672 65.1333 315.672 55.9009C315.672 46.6684 323.226 39.1145 332.459 39.1145C341.691 39.3244 349.245 46.6684 349.245 55.9009Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M325.954 35.9671C326.164 36.8064 325.534 37.6458 324.695 37.8556C323.016 38.4851 321.547 39.3244 320.288 40.3735C319.659 41.003 318.61 41.003 317.98 40.3735C317.351 39.744 317.351 38.6949 318.19 38.0654C319.869 36.5966 321.547 35.5475 323.646 34.918C324.695 34.7081 325.744 35.1278 325.954 35.9671Z",
    fill: "#D1BDD1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M344.629 49.1863L332.249 55.4812C331.829 55.691 331.619 56.1107 331.829 56.5303C332.039 56.95 332.459 57.1598 332.878 56.95L345.258 50.6551C345.678 50.4453 345.888 50.0256 345.678 49.606C345.468 49.1863 345.048 48.9765 344.629 49.1863Z",
    fill: "#D1BDD1"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M331.829 46.8782V55.691C331.829 56.1107 332.249 56.5303 332.668 56.5303C333.088 56.5303 333.508 56.1107 333.508 55.691V46.8782C333.508 46.4585 333.088 46.0389 332.668 46.0389C332.039 46.0389 331.829 46.4585 331.829 46.8782Z",
    fill: "#D1BDD1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M331.409 53.5927C330.15 54.2222 329.521 55.9008 330.15 57.1598C330.78 58.4188 332.459 59.0483 333.718 58.4188C334.976 57.7893 335.606 56.1107 334.977 54.8517C334.137 53.5927 332.668 52.9632 331.409 53.5927Z",
    fill: "#178C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.829 54.6418C332.459 54.2222 333.298 54.6418 333.718 55.2713C334.137 55.9008 333.718 56.7401 333.088 57.1598C332.459 57.5794 331.619 57.1598 331.2 56.5303C330.99 55.9008 331.2 55.0615 331.829 54.6418Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.469 104.371H116.544V138.364H123.469V104.371Z",
    fill: "#2DA38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.754 101.224H108.781V138.364H116.754V101.224Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.947 110.247H131.023V138.364H137.947V110.247Z",
    fill: "#2DA38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.232 101.224H123.259V138.364H131.232V101.224Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.376 104.371H144.452V138.364H151.376V104.371Z",
    fill: "#2DA38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.452 101.224H136.478V138.364H144.452V101.224Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.377 106.333L156.537 107.409L161.461 138.71L168.301 137.634L163.377 106.333Z",
    fill: "#2DA38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.013 100.847L148.136 102.085L153.904 138.776L161.781 137.537L156.013 100.847Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.468 137.212H100.388V144.92H177.468V137.212Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.468 137.212H164.621V144.92H177.468V137.212Z",
    fill: "#2DA38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.781 132.069H116.754V129.131H108.781V132.069Z",
    fill: "#178C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.259 116.541H131.232V112.974H123.259V116.541ZM123.259 110.456V112.345H131.232V110.456H123.259Z",
    fill: "#178C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.478 127.662H144.452V124.095H136.478V127.662ZM136.478 121.577V123.466H144.452V121.577H136.478Z",
    fill: "#178C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.533 84.4376C278.533 84.2278 278.533 84.2278 278.533 84.4376C278.533 70.7987 265.943 59.8876 250.415 59.8876C234.888 59.8876 222.298 70.7987 222.298 84.2278V84.4376H278.533V84.4376Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.911 85.2769C243.911 89.0538 246.848 91.7816 250.415 91.7816C253.982 91.7816 256.92 88.844 256.92 85.2769H243.911V85.2769Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.835 -0.333374H249.786V61.9859H250.835V-0.333374Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.131 90.9423H374.634C371.067 90.9423 368.339 93.8799 368.339 97.2372V133.747L365.612 136.895L364.562 142.35H368.759C370.018 141.931 375.893 130.18 382.608 130.18H415.131C418.698 130.18 421.426 127.453 421.426 123.885V97.2372C421.426 93.6701 418.698 90.9423 415.131 90.9423Z",
    fill: "#178C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.23 123.676C417.23 127.243 414.502 129.971 410.935 129.971H378.201C370.438 129.971 363.933 145.078 363.933 141.721V97.2372C363.933 93.8799 366.661 90.9423 370.228 90.9423H410.935C414.502 90.9423 417.23 93.8799 417.23 97.2372V123.676Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.076 114.653V117.171L373.795 111.925V109.617L384.076 104.371V106.889L376.732 110.666L384.076 114.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.014 118.43L392.889 102.903H394.988L389.112 118.43H387.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.506 107.099V104.581L407.787 109.827V112.135L397.506 117.381V114.863L404.85 111.086L397.506 107.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.704 216.42C448.704 217.05 448.074 217.679 447.445 217.679H424.364C423.734 217.679 423.105 217.05 423.105 216.42V208.866C423.105 208.237 423.734 207.607 424.364 207.607H447.445C448.074 207.607 448.704 208.237 448.704 208.866V216.42Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4804 194.178C72.4804 194.808 71.851 195.437 71.2215 195.437H47.9304C47.301 195.437 46.6715 194.808 46.6715 194.178V186.624C46.6715 185.995 47.301 185.365 47.9304 185.365H71.0116C71.6411 185.365 72.2706 185.995 72.2706 186.624V194.178H72.4804Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.017 194.178C101.017 194.808 100.387 195.437 99.758 195.437H76.6768C76.0473 195.437 75.4178 194.808 75.4178 194.178V186.624C75.4178 185.995 76.0473 185.365 76.6768 185.365H99.758C100.387 185.365 101.017 185.995 101.017 186.624V194.178Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.554 194.178C129.554 194.808 128.924 195.437 128.295 195.437H105.214C104.584 195.437 103.955 194.808 103.955 194.178V186.624C103.955 185.995 104.584 185.365 105.214 185.365H128.295C128.924 185.365 129.554 185.995 129.554 186.624V194.178Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6994 207.188C85.6994 207.817 85.0699 208.447 84.4404 208.447H61.3592C60.7297 208.447 60.1003 207.817 60.1003 207.188V199.634C60.1003 199.004 60.7297 198.375 61.3592 198.375H84.4404C85.0699 198.375 85.6994 199.004 85.6994 199.634V207.188Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.446 207.188C114.446 207.817 113.817 208.447 113.187 208.447H89.8961C89.2666 208.447 88.6371 207.817 88.6371 207.188V199.634C88.6371 199.004 89.2666 198.375 89.8961 198.375H112.977C113.607 198.375 114.236 199.004 114.236 199.634V207.188H114.446Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.216 229.43C421.216 230.059 420.587 230.689 419.957 230.689H396.876C396.247 230.689 395.617 230.059 395.617 229.43V221.876C395.617 221.246 396.247 220.617 396.876 220.617H419.957C420.587 220.617 421.216 221.246 421.216 221.876V229.43Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.158 105.001C296.158 105.63 295.529 106.26 294.899 106.26H271.818C271.189 106.26 270.559 105.63 270.559 105.001V97.447C270.559 96.8175 271.189 96.188 271.818 96.188H294.899C295.529 96.188 296.158 96.8175 296.158 97.447V105.001Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.856 105.001C323.856 105.63 323.226 106.26 322.597 106.26H299.516C298.886 106.26 298.257 105.63 298.257 105.001V97.447C298.257 96.8175 298.886 96.188 299.516 96.188H322.597C323.226 96.188 323.856 96.8175 323.856 97.447V105.001Z",
    fill: "#DBE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4085 292.588L50.8679 292.378C45.2025 284.615 40.3765 274.753 37.6487 262.373L46.6713 261.743L36.8094 258.386C35.7602 252.721 35.1307 246.635 35.3406 240.131C35.3406 240.131 51.4974 241.39 68.0739 249.993L68.9132 257.756L70.382 251.252C80.244 256.707 90.1059 265.1 96.191 277.271L93.2534 289.65L98.2893 281.677C100.388 286.713 101.856 292.378 102.486 298.883C102.906 311.263 102.486 318.607 102.486 318.607H83.6012C83.6012 318.607 67.0247 312.522 53.3859 295.526L62.4085 292.588Z",
    fill: "#19914B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9188 304.548C99.7581 297.204 101.856 291.329 105.004 286.293L107.732 292.168L106.892 283.775C112.768 275.802 120.741 270.766 128.085 267.618L128.715 272.864L130.183 266.779C139.206 263.422 146.76 262.792 146.76 262.792C146.76 272.025 145.291 279.788 142.773 286.503L137.947 287.972L141.934 288.391C138.157 297.624 132.701 304.338 127.456 308.955L118.013 309.374L124.098 311.682C117.594 316.718 112.348 318.607 112.348 318.607H98.9188C98.9188 318.607 98.4991 313.361 98.9188 304.548Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M132.491 277.061C135.429 274.333 141.514 267.828 141.514 267.828C141.514 267.828 134.17 272.654 131.232 275.382C106.682 298.463 101.647 317.558 101.437 318.397L102.486 318.607H103.535C104.374 316.299 110.25 298.253 132.491 277.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M95.7713 318.607H97.8696C95.9812 312.522 84.6504 278.739 50.2384 251.252C47.3008 248.944 40.5863 245.376 40.5863 245.376C40.5863 245.376 45.832 250.412 48.7696 252.721C81.9226 278.949 93.4632 311.263 95.7713 318.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.531 319.446C120.531 319.866 120.112 320.285 119.692 320.285H76.8867C76.4671 320.285 76.0474 319.866 76.0474 319.446C76.0474 319.026 76.4671 318.607 76.8867 318.607H119.692C120.112 318.607 120.531 319.026 120.531 319.446Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5521 96.188C82.5521 97.0273 81.9226 97.6568 81.0833 97.6568H43.9436C43.1043 97.6568 42.4748 97.0273 42.4748 96.188C42.4748 95.3487 43.1043 94.7192 43.9436 94.7192H80.8735C81.7128 94.7192 82.5521 95.3487 82.5521 96.188Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.514 40.7932C141.514 41.6325 140.885 42.262 140.045 42.262H123.469C122.629 42.262 122 41.6325 122 40.7932C122 39.9539 122.629 39.3244 123.469 39.3244H140.045C140.675 39.3244 141.514 39.9539 141.514 40.7932Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.314 40.7932C154.314 41.6325 153.684 42.262 152.845 42.262H146.97C146.13 42.262 145.501 41.6325 145.501 40.7932C145.501 39.9539 146.13 39.3244 146.97 39.3244H152.845C153.684 39.3244 154.314 39.9539 154.314 40.7932Z",
    fill: "#17BB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0303 96.188C97.0303 97.0273 96.4008 97.6568 95.5615 97.6568H87.7978C86.9585 97.6568 86.329 97.0273 86.329 96.188C86.329 95.3487 86.9585 94.7192 87.7978 94.7192H95.3517C96.191 94.7192 97.0303 95.3487 97.0303 96.188Z",
    fill: "#17BB99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_7406",
    x1: 240.539,
    y1: 318.4,
    x2: 271.054,
    y2: 318.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D342B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291C17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_7406",
    x1: 133.23,
    y1: 212.218,
    x2: 313.143,
    y2: 212.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D68C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_7406",
    x1: 133.134,
    y1: 212.218,
    x2: 179.977,
    y2: 212.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D68C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_7406",
    x1: 281.116,
    y1: 318.4,
    x2: 311.63,
    y2: 318.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D342B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291C17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_7406",
    x1: 304.923,
    y1: 294.043,
    x2: 304.923,
    y2: 262.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "#444199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7_7406",
    x1: 274.744,
    y1: 286.238,
    x2: 292.311,
    y2: 235.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "#444199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7_7406",
    x1: 334.384,
    y1: 152.977,
    x2: 319.064,
    y2: 134.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "#F4A079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7_7406",
    x1: 351.553,
    y1: 237.567,
    x2: 327.654,
    y2: 175.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "#C73669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2577E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7_7406",
    x1: 250.507,
    y1: 208.613,
    x2: 246.83,
    y2: 204.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "#F4A079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7_7406",
    x1: 331.819,
    y1: 218.39,
    x2: 328.552,
    y2: 252.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "#F8981C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4731C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7_7406",
    x1: 325.274,
    y1: 173.484,
    x2: 281.461,
    y2: 197.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    stopColor: "#E6426B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2577E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_7406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 490,
    height: 326.667,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUx);
export default __webpack_public_path__ + "static/media/UiUx.cd25e57e4de9d699d506c125f3e219ee.svg";
export { ForwardRef as ReactComponent };